(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureSectionListController', Controller);

    Controller.$inject = ['$scope', '$window', '$state', '$stateParams', '$location', '$anchorScroll', '$timeout', 'procedureService', 'permissionService', 'historyCtxtService', 'attachmentService', 'procedure', 'sectionBlockLookups', 'notificationService', '$http'];

    function Controller($scope, $window, $state, $stateParams, $location, $anchorScroll, $timeout, procedureService, permissionService, historyCtxtService, attachmentService, procedure, sectionBlockLookups, notificationService, $http) {

        $scope.procedure           = procedure;
        $scope.sectionBlockLookups = sectionBlockLookups;
        $scope.canEditProcedure    = permissionService.hasPermission('ProceduresManagement', 'Procedure', 'Edit', procedure);
        $scope.isInViewMode        = true;
        $scope.historyCtxtService  = historyCtxtService;

        $scope.ctxtCtrl = {
            legalEntities: null,
            locations: null,
            referenceBlock: null,
            isParticipantContentVisible: false,
            isReferenceContentVisible: false,
            isFootnoteBlockVisible: false,
            hasHistoryContext: false,
            isTocOpen: false,

            canAddLegalEntities: $scope.procedure.MetadataBlock.HasMetadataBlock_AddLegalEntities,
            canAddLocations: $scope.procedure.MetadataBlock.HasMetadataBlock_AddLocations,

            availableLang: sectionBlockLookups.Language.LookupAttributeValues,

            // Active lang, might be changed in different places, initializes in english
            langAttr: null, // Default set in initLanguage
            lang: 'EN'
        };

        // Translations
        $scope.labels = {
            EN: {
                Summary: 'Summary',
                TOC: 'Table of Contents',
                Print: 'Print',
                ExportWord: 'Export as Word Document',
                ShareProcedure: 'Share Procedure',
                EditProcedure: 'Edit Procedure',
                NoKeyRoles: 'No Key Roles or Responsibilities',
                Responsibilities: 'Responsibilities',
                OtherRoles: 'Other Roles',
                EffectiveDate: 'Effective Date',
                IssuingBU: 'Issuing Business Unit',
                LegalEntities: 'Legal Entities',
                ReviewCycle: 'Review Cycles',
                MeetingFrequency: 'Meeting Frequency',
                Locations: 'Locations',
                Objectives: 'Objectives',
            },
            FR: {
                Summary: 'Sommaire',
                TOC: 'Table des matières',
                Print: 'Imprimer',
                ExportWord: 'Exporter en document Word',
                ShareProcedure: 'Partager la procedure',
                EditProcedure: 'Modifier la procedure',
                NoKeyRoles: 'Aucuns rôles clés ni responsabilités',
                Responsibilities: 'Responsabilités',
                OtherRoles: 'Autres roles',
                EffectiveDate: 'Date effective ',
                IssuingBU: 'Unité d\'affaire émetrice',
                LegalEntities: 'Entités légales',
                ReviewCycle: 'Cycle de révision du TOR',
                MeetingFrequency: 'Fréquence des rencontres',
                Locations: 'Emplacements',
                Objectives: 'Objectifs',
            }
        };

        $scope.ctxtCtrl.isRefCodeHidden = $scope.procedure.MetadataBlock.ProcedureType.Value === 'Reference-Document';

        $scope.ctxtCtrl.hasHistoryContext = historyCtxtService.hasContext();

        init();

        // Edit Procedure
        $scope.editProcedure = function () {
            $scope.closeTableOfContents();
            $state.go('procedure.edit', {
                ProcedureType: $scope.procedure.MetadataBlock.ProcedureType.Value,
                ProcedureCode: $scope.procedure.MetadataBlock.ProcedureCode.Code
            });
        };

        // Get Procedure Status Value
        $scope.getProcedureStatusValue = function() {
            return $scope.procedure.IsPublished ? 'Published' : 'Draft';
        };

        // Go To Search Results
        $scope.goToSearchResults = function () {
            $state.go('newProcedureSearch');
        };

        // Print Procedure
        $scope.printProcedure = function () {
            $scope.closeTableOfContents();
            $window.print();
        };

        // Change Language
        $scope.changeLanguage = function (langAttr) {
            $scope.ctxtCtrl.isSwitchingLanguage = true;
            // This delay adds a no-transition class to make the ng-if instantaneous
            $timeout(function () {
                $scope.ctxtCtrl.langAttr = langAttr;
                $scope.ctxtCtrl.lang = langAttr.Value;
                $location.search('lang', langAttr.Value);
                $scope.ctxtCtrl.isSwitchingLanguage = false;
            }, 0);
        };

        // Copy to clipboard
        $scope.getUrlToCopy = function () {
            return $location.absUrl();
        };

        // Clipboard Copy Success
        $scope.clipboardCopySuccess = function (event) {
            var code = _.get($scope.procedure, 'MetadataBlock.ProcedureCode.Code');

            if (_.isUndefined(code)) {
                code = '';
            }

            notificationService.notify("Procedure " + code + " URL copied to clipboard");
        };

        // Clipboard Copy Error
        $scope.clipboardCopyError = function (event) {
            notificationService.warn("Could not copy procedure to clipboard");
        };

        // Table of Contents
        $scope.showTableOfContents = function () {
            if ($scope.ctxtCtrl.isTocOpen) {
                $scope.closeTableOfContents();

                return;
            }

            $scope.ctxtCtrl.yScrollBeforeToc = window.pageYOffset;
            window.scrollTo(0, 0);
            $scope.ctxtCtrl.isTocOpen = true;
        };

        // Click on Table of Contents item
        $scope.clickOnTocItem = function (anchor) {
            $scope.ctxtCtrl.isTocOpen = false;

            // If header is affixed, offset is different
            var affixedHeader = document.querySelector('.procedure-content .procedure-title-container');
            if (affixedHeader.classList.contains('affix')) {
                // Offset = 2 times header height - 15px (padding difference)
                $anchorScroll.yOffset = affixedHeader.offsetHeight * 2 - 13;
            } else {
                $anchorScroll.yOffset = affixedHeader.offsetHeight;
            }

            $timeout(function () {
                $location.hash(anchor);
                $anchorScroll(); // Force scroll even if anchor didn't change
            })
        };

        // Close Table of Contents
        $scope.closeTableOfContents = function () {
            window.scrollTo(0, $scope.ctxtCtrl.yScrollBeforeToc);
            $scope.ctxtCtrl.isTocOpen = false;
        };

        // Navigate to Appendix/Section
        $scope.navigateToSection = function (section) {
            if ($location.hash() === section.Anchor) {
                // Force change of URL to scroll again
                $location.url('#');
                $timeout(function () {
                    $location.url('#' + section.Anchor);
                });
            } else {
                $location.url('#' + section.Anchor);
            }
        };

        // Get Procedure URL
        $scope.getProcedureUrl = function (procedure) {
            return $state.href('procedure.view', {
                ProcedureType: procedure.MetadataBlock.ProcedureType.Value,
                ProcedureCode: procedure.MetadataBlock.ProcedureCode.Code
            });
        };

        // Download Procedure as Docx
        $scope.downloadProcedureAsDocx = function () {
            var version = $scope.procedure.IsPublished ? 'Published' : 'WorkingCopy';

            procedureService
                .getProcedureAsDocxUrl(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.MetadataBlock.ProcedureCode.Code,
                    $scope.ctxtCtrl.lang,
                    version
                ).then(function (data) {
                var file = new Blob([data], {
                  type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                });
                var fileURL = window.URL.createObjectURL(file);
                var fileName = $scope.procedure.MetadataBlock.ProcedureCode.Code
                  + $scope.procedure.MetadataBlock['TitleHtml' + $scope.ctxtCtrl.lang]
                  + '.docx';
                var a = document.createElement('a');

                document.body.appendChild(a);

                a.href = fileURL;
                a.download = fileName;

                a.click();
            });
        };

        // Get Attachment URL
        $scope.getAttachmentUrl = function (attachment) {
            return attachmentService.getDownloadUrl(attachment.AttachmentExternalID);
        };

        // Should the attachment be displayed
        $scope.isAttachmentVisible = function (attachment) {
            if ($scope.ctxtCtrl.lang === 'EN') {
                return attachment.LanguageID === $scope.ctxtCtrl.langAttr.LookupAttributeValueID;
            }

            return !!attachment.TitleFR;
        };

      $scope.downloadAttachment = function (existingAttachment) {
        $http({
          method: 'GET',
          url: $scope.getAttachmentUrl(existingAttachment),
          responseType: 'blob'
        }).then(function (response) {
          const file = getFileFromBlob(response.data, existingAttachment.FileName, response.data.type);
          downloadFile(file);
        });
      }

      function getFileFromBlob(blobPart, fileName, contentType) {
        if (!fileName || !contentType) {
          return;
        }

        const blob = new Blob([blobPart], { type: contentType });
        const file = new File([blob], fileName);

        return file;
      }

      function downloadFile(file) {
        const fileName = file.name;

        // For IE
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          window.navigator.msSaveOrOpenBlob(file, fileName);
        } else {
          const link = document.createElement('a');

          link.style.display = 'none';
          link.href = window.URL.createObjectURL(file);
          link.download = fileName;

          document.body.appendChild(link);
          link.click();

          // For Firefox, we need to postpone the removal of the link
          setTimeout(() => {
            window.URL.revokeObjectURL(link.href);
            link.remove();
          }, 0)
        }
      }

        function init() {
            initLanguage();

            updateLegalEntities();
            updateLocations();

            // Participant Block
            $scope.ctxtCtrl.participantBlock = {};
            $scope.procedure.ParticipantBlock._isEmpty = true;

            initResponsibilities();

            if ($scope.procedure.ParticipantBlock.Stakeholders.length > 0) {
                $scope.procedure.ParticipantBlock._isEmpty = false;
                $scope.ctxtCtrl.isParticipantContentVisible = true;
                $scope.ctxtCtrl.participantBlock.stakeholders = _.map($scope.procedure.ParticipantBlock.Stakeholders,
                    function (element) {
                        return {
                            'TitleEN': element.TitleEN,
                            'CSSIcon': typeCodeToCssIcon(element.TypeCode),
                            'ResponsibilityStr': element.responsibilityStr
                        };
                    });
            }
            if ($scope.procedure.ParticipantBlock.Participants.length > 0) {
                $scope.procedure.ParticipantBlock._isEmpty = false;
                $scope.ctxtCtrl.isParticipantContentVisible = true;
                $scope.ctxtCtrl.participantBlock.otherParticipants = _.map($scope.procedure.ParticipantBlock.Participants,
                    function (element) {
                        return {
                            'TitleEN': element.TitleEN,
                            'CSSIcon': typeCodeToCssIcon(element.TypeCode)
                        };
                    });
            }
            setTOCItemVisibility($scope.procedure.ParticipantBlock.Anchor, !$scope.procedure.ParticipantBlock._isEmpty);

            // Reference Block
            $scope.ctxtCtrl.referenceBlock = _.groupBy($scope.procedure.ReferenceBlock.References, 'TypeCode');
            $scope.procedure.ReferenceBlock._isEmpty = $scope.procedure.ReferenceBlock.References.length === 0;
            setTOCItemVisibility($scope.procedure.ReferenceBlock.Anchor, !$scope.procedure.ReferenceBlock._isEmpty);

            // Footnote Block
            $scope.procedure.FootnoteBlock._isEmpty =
                _.get($scope, 'procedure.FootnoteBlock.Footnotes'+$scope.ctxtCtrl.lang, []).length === 0;
            setTOCItemVisibility($scope.procedure.FootnoteBlock.Anchor, !$scope.procedure.FootnoteBlock._isEmpty);

            // Table of Contents
            initTableOfContents();

            // Scroll to anchor on page load, if any
            $timeout(function () {
                var titleEl = document.querySelector('.procedure-content .procedure-title-container');
                $anchorScroll.yOffset = titleEl.offsetHeight * 2;

                $anchorScroll();
            }, 100);
        }

        function initLanguage() {
            var defaultLang = $stateParams.lang;
            var defaultLanguage = _.find(sectionBlockLookups.Language.LookupAttributeValues, {Value: defaultLang});
            if (!defaultLanguage) {
                defaultLanguage = _.find(sectionBlockLookups.Language.LookupAttributeValues, {Value: 'EN'});
            }

            $scope.ctxtCtrl.langAttr = defaultLanguage;
            $scope.ctxtCtrl.lang = defaultLanguage.Value;
        }

        function initTableOfContents() {
            var dynamicNumber = 1;

            _.each($scope.procedure.TableOfContents, function (tocItem) {
                if (tocItem.IsDynamic) {
                    tocItem._index = dynamicNumber++;
                    tocItem.Depth = 0;
                }

                // For ToC, the title of the Metadata block is 'Summary'
                // Server should return a SummaryBlock to not use the MetadataBlock
                if (tocItem.MetadataBlockID) {
                    tocItem.TitleEN = 'Summary';
                    tocItem.TitleFR = 'Sommaire';
                }
            });
        }

        function initResponsibilities() {
            _.each($scope.procedure.ParticipantBlock.Stakeholders, function (participant) {
                $scope.procedure.ParticipantBlock._isEmpty = false;

                // Business Unit
                if (participant.BusinessUnitID) {
                    participant.Responsibilities = _.filter(
                        $scope.procedure.ParticipantBlock.Responsibilities,
                        {BusinessUnitID: participant.BusinessUnitID}
                    );

                    participant.responsibilityStr = '<ul>' + _.map(participant.Responsibilities, function (value) { return '<li>'+ value.TitleEN +'</li>'; }).join('') + '</ul>';
                }

                // Committee
                if (participant.CommitteeID) {
                    participant.Responsibilities = _.filter(
                        $scope.procedure.ParticipantBlock.Responsibilities,
                        {CommitteeID: participant.CommitteeID}
                    );

                    participant.responsibilityStr = '<ul>' + _.map(participant.Responsibilities, function (value) { return '<li>' + value.TitleEN + '</li>'; }).join('') + '</ul>';
                }

                // Corporate Role
                if (participant.CorporateRoleID) {
                    participant.Responsibilities = _.filter(
                        $scope.procedure.ParticipantBlock.Responsibilities,
                        {CorporateRoleID: participant.CorporateRoleID}
                    );

                    participant.responsibilityStr = '<ul>' + _.map(participant.Responsibilities, function (value) { return '<li>' + value.TitleEN + '</li>'; }).join('') + '</ul>';
                }
            });
        }

        function setTOCItemVisibility(anchor, isVisible) {
            if (!isVisible) {
                $scope.procedure.TableOfContents = _.reject($scope.procedure.TableOfContents, {Anchor: anchor});
            }
        }

        function typeCodeToCssIcon(typecode) {
            if(typecode === 'BusinessUnit') {
                return 'fa-university';
            }
            else if(typecode === 'Committee') {
                return 'fa-users';
            }
            else if(typecode === 'CorporateRole') {
                return 'fa-tag';
            }
            else {
                return undefined;
            }
        }

        function updateLegalEntities() {
            $scope.ctxtCtrl.legalEntities =
                _.join(_.map($scope.procedure.MetadataBlock.LegalEntities, 'Title' + $scope.ctxtCtrl.lang), ', ');
        }

        function updateLocations() {
            $scope.ctxtCtrl.locations =
                _.join(_.map($scope.procedure.MetadataBlock.Locations, 'Title' + $scope.ctxtCtrl.lang), ', ');
        }
    }
})();
